export default "__VITE_ASSET__5EkMw848__"